import { useSyncExternalStore } from 'react'

import { getAuthSessionSnapshot, subscribeAuthSession } from '@/lib/authSession'
import { isCoach } from '@/lib/cookies'

/**
 * Re-render when the auth token changes. Entitlement checks such as isCoach()
 * read localStorage synchronously, so without this subscription a component
 * keeps showing the pre-refresh state until something else re-renders it.
 *
 * The returned version number is only a change signal; read the entitlement
 * itself with the usual helper.
 */
export function useAuthSession(): number {
    return useSyncExternalStore(subscribeAuthSession, getAuthSessionSnapshot)
}

/**
 * Reads an entitlement (isCoach, isBusiness, ...) and re-reads it when the
 * token changes, e.g. a grant activated mid-session.
 */
export function useEntitlement(check: () => boolean): boolean {
    useAuthSession()
    return check()
}

export function useIsCoach(): boolean {
    return useEntitlement(isCoach)
}
